import {
  CampaignStatus,
  CampaignSortBy,
  SortDirection
} from "src/graphql/generated/globalTypes";

export type CampaignStatusLabel = {
  value: CampaignStatus;
  label: string;
};

export const CAMPAIGN_STATUSES: Readonly<CampaignStatusLabel[]> = [
  { value: CampaignStatus.DRAFT, label: "Draft" },
  { value: CampaignStatus.ACTIVE, label: "Active" },
  { value: CampaignStatus.PAUSING, label: "Pausing" },
  { value: CampaignStatus.PAUSED, label: "Paused" },
  { value: CampaignStatus.ARCHIVED, label: "Archived" },
  { value: CampaignStatus.STALLED, label: "Stalled" },
  { value: CampaignStatus.COMPLETE, label: "Complete" }
];

export const CAMPAIGN_STATUS_LABELS: Readonly<CampaignStatusLabel[]> =
  CAMPAIGN_STATUSES.concat([
    { value: CampaignStatus.PERMANENTLY_ARCHIVED, label: "Archived" }
  ]);

export const CAMPAIGN_SORTS = [
  {
    value: { sortBy: CampaignSortBy.CREATED_AT, direction: SortDirection.DESC },
    key: "created_at_desc",
    label: "Created At, Newest First"
  },
  {
    value: { sortBy: CampaignSortBy.CREATED_AT, direction: SortDirection.ASC },
    key: "created_at_asc",
    label: "Created At, Oldest First"
  },
  {
    value: { sortBy: CampaignSortBy.NAME, direction: SortDirection.ASC },
    key: "name_asc",
    label: "Name, A-Z"
  },
  {
    value: { sortBy: CampaignSortBy.NAME, direction: SortDirection.DESC },
    key: "name_desc",
    label: "Name, Z-A"
  }
] as const;
